/* global window */

import get from 'lodash/get';
import merge from 'lodash/merge';

const settings = merge({
  playerClass: 'hearstLumierePlayer',
  loadedClass: 'playerLoaded',
  dataAttributePrefix: 'data-player',
  loggingLevel: 'all',
  timeout: 5000,

  nitehawkBaseUrl: get(window, 'LUMIERE_NITEHAWK_URL', 'https://nitehawk.hearst.io'),
  animeBaseUrl: 'https://anime.htvtools.us/v1/prod/animated-gifs',
  defaultScripts: [
    'https://imasdk.googleapis.com/js/sdkloader/ima3.js',
  ],
  fallbackScripts: [
    'https://assets.htvapps.com/lumiere/fallback/ima3.js',
  ],
  nowcastScripts: [
    'https://imasdk.googleapis.com/js/sdkloader/ima3_dai.js',
  ],

  adSettings: {
    adsRenderingSettings: {
      bitrate: -1,
      mimeTypes: [
        'video/mp4',
        'video/webm',
      ],
      loadVideoTimeout: 10000,
    },
    contribAdsSettings: {
      timeout: 10000,
      prerollTimeout: 1000,
    },
  },
  canAutoplay: true,
  imaSdkAvailable: false,
  enableAmazonBids: get(window, 'LUMIERE_AMAZON_BIDS', true),

  // google.ima.ImaSdkSettings.VpaidMode.DISABLED = 0
  // google.ima.ImaSdkSettings.VpaidMode.ENABLED = 1
  // google.ima.ImaSdkSettings.VpaidMode.INSECURE = 2
  vpaidMode: get(window, 'LUMIERE_VPAID_INSECURE', false) ? 2 : 1,

  enableAutoAdvance: false,
  autoAdvanceDelayInSeconds: 0,

  enableQualityLevels: false,
}, window.playerSettings);

export default settings;



// WEBPACK FOOTER //
// ./src/settings.js